import { reducerWithInitialState } from 'typescript-fsa-reducers';

export interface TableRowTitleProps {
  header: string[];
  data: { [key: string]: string[] };
}

export interface ReportTableRowState {
  tableRowTitle: TableRowTitleProps;
  displayKeyList: string[];
}

export const getReportTableRowKeys = () => {
  return reportTableRowinitialState.displayKeyList;
};

const reportTableRowinitialState: ReportTableRowState = {
  tableRowTitle: {
    header: ['商材カテゴリ', '契約形態'],
    data: {
      total: ['', ''],
      customers: ['', ''],
      smartphoneNew: ['HSスマホ', '純新規'],
      smartphoneTransfer: ['HSスマホ', '番号移行'],
      smartphoneChange: ['HSスマホ', '機変'],
      smartphoneMnp: ['HSスマホ', '乗換（転入）'],
      smartphoneContrChg: ['HSスマホ', '契約変更'],
      garakeiNew: ['HSスマホ以外', '純新規'],
      garakeiTransfer: ['HSスマホ以外', '番号移行'],
      garakeiChange: ['HSスマホ以外', '機変'],
      garakeiMnp: ['HSスマホ以外', '乗換（転入）'],
      garakeiContrChg: ['HSスマホ以外', '契約変更'],
      tabletNew: ['タブレット', '純新規'],
      tabletChange: ['タブレット', '機変'],
      otherNew: ['その他', '純新規'],
      otherTransfer: ['その他', '番号移行'],
      otherChange: ['その他', '機変'],
      otherMnp: ['その他', '乗換（転入）'],
      otherContrChg: ['その他', '契約変更'],
      simNew: ['SIM単体', '純新規'],
      simTransfer: ['SIM単体', '番号移行'],
      simChange: ['SIM単体', '機変'],
      simMnp: ['SIM単体', '乗換（転入）'],
      simContrChg: ['SIM単体', '契約変更'],
      hikariNew: ['ソフトバンク光', '純新規'],
      hikariDiverted: ['ソフトバンク光', '転用'],
      hikariChange: ['ソフトバンク光', '事業者変更'],
      airNew: ['ソフトバンクAir', '純新規'],
      airChange: ['ソフトバンクAir', '機変'],
      denwaNew: ['おうちのでんわ', '純新規'],
      denkiNew: ['おうちでんき', '純新規'],
    },
  },
  displayKeyList: [
    'total',
    'customers',
    'smartphoneNew',
    'smartphoneTransfer',
    'smartphoneChange',
    'smartphoneMnp',
    'smartphoneContrChg',
    'garakeiNew',
    'garakeiTransfer',
    'garakeiChange',
    'garakeiMnp',
    'garakeiContrChg',
    'tabletNew',
    'tabletChange',
    'otherNew',
    'otherTransfer',
    'otherChange',
    'otherMnp',
    'otherContrChg',
    'simNew',
    'simTransfer',
    'simChange',
    'simMnp',
    'simContrChg',
    'hikariNew',
    'hikariDiverted',
    'hikariChange',
    'airNew',
    'airChange',
    'denwaNew',
    'denkiNew',
  ],
};

export const ReportTableRowReducer = reducerWithInitialState(reportTableRowinitialState);
